import React from 'react';

interface DentalIconProps {
  className?: string;
  size?: number;
}

export const DentalIcon: React.FC<DentalIconProps> = ({ 
  className = '', 
  size = 150 
}) => {
  return (
    <svg 
      id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      version="1.1" 
      viewBox="0 0 150 150"
      width={size}
      height={size}
      className={className}
    >
      <defs>
        <style>
          {`.st0 {
            fill: none;
            stroke: #e3e3e3;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 9px;
          }`}
        </style>
      </defs>
      <path 
        className="st0" 
        d="M107.89,15.09H39.92c-9.09,0-15.65,8.66-13.24,17.43,4.85,17.62,12.16,32.29,21.04,42.24,1.24,1.39,1.78,3.25,1.47,5.08l-8.6,50.81c-.53,3.76,4.25,5.8,6.61,2.83l25.38-34.7c1.2-1.65,3.66-1.65,4.87,0l25.38,34.7c2.36,2.97,7.13.93,6.61-2.83l-8.6-50.81c-.31-1.83.23-3.7,1.47-5.08,8.87-9.96,16.18-24.62,21.04-42.24.37-1.33.53-2.66.5-3.96"
      />
      <path 
        className="st0" 
        d="M87.87,63.76c0,7.11-5.76,12.87-12.87,12.87s-12.87-5.76-12.87-12.87"
      />
      <path 
        className="st0" 
        d="M96.88,30.53c1.76.62,3.41,1.63,4.81,3.04,2.51,2.51,3.77,5.81,3.77,9.1"
      />
    </svg>
  );
};
